import API from 'services/TAPS_API';

export default function getAppealCategories() {
  return API.request({
    method: 'GET',
    url: `/dictionary/theme/category`,
  });
}
